import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "@/lang/zh";
import en from "@/lang/en";
import ja from "@/lang/ja";

Vue.use(VueI18n);

const messages = {
    en,
    ja,
    zh,
};

let i18n = new VueI18n({
    locale: localStorage.getItem("language") || "en",
    messages: messages,
});

export default i18n;
